import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import Counters from '../models/Counters';
import Presence from '../models/Presence';
import TaskContainer from '../models/TaskContainer';
import { parseDossierStacks } from './dossierStackConverters';
import { parsePlanningTasks } from './planningTaskConverters';
import { parseTasks } from './taskConverters';

const SCHEMA = {
  counters: (data: any) => parseCounters(data.counters) ?? new Counters(),
  presences: (data: any) => parsePresences(data.presences),
  tasks: (data: any) => parseTasks(data.eventTasks),
  planningTasks: (data: any) => parsePlanningTasks(data.planning),
  stacks: (data: any) => parseDossierStacks(data.dossierStacks),
};

export const PRESENCE_SCHEMA = {
  outletId: 'moboOutletId',
  clockedOn: (data: any) => parseMoment(data.clockedOn),
  isPresent: 'isPresent',
};

const COUNTERS_SCHEMA = {
  assignedDossiers: 'assignedDossiers',
  vehiclesExpected: 'waitingForCheckIn',
  memos: 'memos',
  hasMemoAlert: 'hasMemoAlert',
};

export function parseCounters(data: any): Counters | null {
  return parseEntity(data, COUNTERS_SCHEMA, Counters);
}

export function parsePresences(data: any): Array<Presence> {
  return parseEntities(data, PRESENCE_SCHEMA, Presence);
}

export function parseTaskContainer(data: any): TaskContainer | null {
  return parseEntity(data, SCHEMA, TaskContainer);
}
